export enum ContractPaymentType {
    cptNow = 0,
    cptCredit = 1
}